import React from 'react';
import "./filter.scss";
import Dropdown from '../../../common/dropdown-v2/dropdown';
import DropdownV4 from '../../../common/dropdown-v4/dropdown';
import SchoolApi from '../../../../apis/school'
import MasterDataApi from '../../../../apis/master-data'
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import HomeworkApi from '../../../../apis/homework';
import { Constants, ImageConstants } from '../../../../constants/constants';
import { getImageSource } from '../../../../utility/image-source';
import SessionCache from '../../../routes/session-cache';
import CwConfirmationModal from '../../../common/cw-confirmation-modal/cw-confirmation-modal'
import TestApi from '../../../../apis/test';

class FilterComponent extends React.Component {
    state = {
        showShadow: false,
        assignFrom: '',
        showFilters: true,
        disableGo: true,
        selectedElo: false,
        skillDropdownItems: [],
        autoNext: false,
        boardsDropdownItems: [],
        classDropdownItems: [],
        selectedRevisionType: 'ONLY_REVISION',
        chapterDropDownItems: [],
        teachersDropDownItems: [],
        selectedBoard: "",
        selectedClass: "",
        selectedChapterKey: [],
        selectedTeachersId: [],
        eloDropdownItems: [],
        selectedElo: [],
        showTimer: false,
        showLeaderboard: false,
        disableClass: true,
        disableChapters: true,
        selectedStandardHomeworkId: '',
        assessmentQuestionTypeDropDownItems: [{ title: 'MCQ', value: '668e24ddb117d636eb2de9c9' },
        { title: 'STR', value: '6694f6ac4580972d48b24e7c' }, { title: 'CASE STUDY', value: '669285f24580972d48b24e7b' }],
        leaderboardLimit: '5',
        streamingDropdown: [{ title: "Default", value: "DEFAULT" }, { title: "Previous Year Mark", value: "PREVIOUS_YEAR_MARK" }],
        subSubjectsDropDownItems: [
            {
                title: 'Physics',
                value: '6825751af19678f87dd72e9c'
            },
            {
                title: 'Chemistry',
                value: '68ad5e67a5611fe85d55d17c'
            },
            {
                title: 'Biology',
                value: '68ad5e67a5611fe85d55d17d'
            }
        ]
    }

    classSectionHash = {}
    conceptHash = {}
    eloHash = {}
    sectionHash = {}


    constructor(props) {
        super(props)
        this.user = SessionCache.getUser()
    }

    componentDidMount() {

        this.getClasses()

        if (this.props.delegate?.props?.delegate?.props?.delegate?.props?.location?.state?.homeworkAssignPayload?.from === 'RECOMMANDATION_REPORT') {
            let filterPayload = {
                ...this.props.delegate?.props?.delegate?.props?.delegate?.props?.location?.state?.homeworkAssignPayload
            }
            console.log(filterPayload)
            this.setState({
                recommendationReportHomeworkId: filterPayload.homeworkId,
                assignFrom: this.props.delegate?.props?.delegate?.props?.delegate?.props?.location?.state?.homeworkAssignPayload?.from,
                assigningFrom: filterPayload.assigningFrom ? filterPayload.assigningFrom : ''
            })
            this.onSelectDropDown({ value: filterPayload.selectedBoard }, "selectedBoard")
            this.onSelectDropDown({ value: filterPayload.selectedClass }, "selectedClass")

            setTimeout(() => {
                this.onMultiSelectDropdownForChapter([{ value: filterPayload.chapterKey }], "selectedChapterKey", true)
            }, 2000)

            let options = []

            filterPayload.conceptKey.forEach((concept, index) => {
                options.push({ value: concept.conceptKey, order: index + 1 })
            })

            setTimeout(() => {
                this.onMultiSelectDropdown([...options], "selectedConcept")
            }, 3000)


        } else if (this.props.delegate?.props?.delegate?.props?.delegate?.props?.location?.state?.homeworkAssignPayload) {
            let filterPayload = {
                ...this.props.delegate?.props?.delegate?.props?.delegate?.props?.location?.state?.homeworkAssignPayload
            }
            console.log(filterPayload)

            let isFromPk = false

            if (this.props.delegate?.props?.delegate?.props?.delegate?.props?.location?.state?.homeworkAssignPayload?.from === 'LEARNING_RESOURCES' &&
                this.props.delegate?.props?.delegate?.props?.delegate?.props?.location?.state?.homeworkAssignPayload?.forWhat === 'PREVIOUS_KNOWLEDGE') {
                isFromPk = true
            }

            this.setState({ isFromPk, assignFrom: this.props.delegate?.props?.delegate?.props?.delegate?.props?.location?.state?.homeworkAssignPayload?.from })


            this.onSelectDropDown({ value: filterPayload.selectedBoard ? filterPayload.selectedBoard : "CBSE" }, "selectedBoard")
            this.onSelectDropDown({ value: filterPayload.selectedClass }, "selectedClass")

            setTimeout(() => {
                this.onMultiSelectDropdownForChapter([{ value: filterPayload.chapterKey }], "selectedChapterKey", true)
            }, 2000)

            setTimeout(() => {
                this.onMultiSelectDropdown([{ value: filterPayload.conceptKey, order: 1 }], "selectedConcept")
            }, 3000)

        }

        if (this.props.isFromDraft) {
            let homeworkAssignPayload = this.props.selectedHomework

            this.onSelectDropDown({ value: homeworkAssignPayload.board }, "selectedBoard")
            this.onSelectDropDown({ value: homeworkAssignPayload.class }, "selectedClass")


            setTimeout(() => {
                this.onSelectDropDown({ value: homeworkAssignPayload.sectionId, sectionId: homeworkAssignPayload.sectionId, title: homeworkAssignPayload.section }, "selectedSection")
            }, 1000)

            setTimeout(() => {
                this.onSelectDropDown({ value: homeworkAssignPayload.chapterKey }, "selectedChapterKey")
            }, 2000)

            console.log(homeworkAssignPayload.conceptKeysList)

            setTimeout(() => {
                this.onMultiSelectDropdown(homeworkAssignPayload.conceptKeysList, "selectedConcept")
            }, 3500)

            setTimeout(() => {
                this.onSelectElo(homeworkAssignPayload.eloIdsList)
            }, 4500)
        }
    };

    getClasses(payload = {}) {

        payload.type = this.props.type

        SchoolApi.getClassAndBoard(payload)
            .then(school => {
                // console.log(school)
                let classes = [], boards = [];
                for (let i = 0; i < school.classes.length; i++) {
                    classes.push({
                        title: school.classes[i].name,
                        value: school.classes[i].name,
                    })
                }

                for (let i = 0; i < school.boards.length; i++) {
                    boards.push({
                        title: school.boards[i].name,
                        value: school.boards[i].name,
                    })
                }

                if (boards.length > 1) {
                    this.setState({ boardsDropdownItems: boards })
                } else {
                    this.setState({ selectedBoard: school?.boards[0]?.name })
                }
                this.setState({ classDropdownItems: classes, })
            }).catch(err => {
            })
    }

    // componentDidUpdate(prevProps) {
    //     if (prevProps.selectedFilter !== this.props.selectedFilter) {
    //         // Re-run filter / API call here
    //         console.log(this.props.selectedFilter)
    //         this.setState({ reloadDropdown: true }, () => {
    //             this.setState({ reloadDropdown: false })
    //         })
    //     }
    // }




    getSections(payload = {}) {

        if (!payload.class) payload.class = this.state.selectedClass
        if (!payload.board) payload.board = this.state.selectedBoard

        if (!payload.class || !payload.board) {
            this.setState({ sectionDropdownItems: [], selectedSection: "" })
            this.reloadDropdown()
            return
        }

        SchoolApi.getSections(payload)
            .then(response => {
                let sections = []
                // console.log(response)
                for (let i = 0; i < response.response.length; i++) {

                    if (response.response[i].section !== 'No Sections') {
                        sections.push({
                            title: response.response[i].section,
                            value: response.response[i]._id,
                            sectionId: response.response[i]._id
                        })

                        this.sectionHash[response.response[i]._id] = response.response[i].section
                    }


                }
                this.classSectionHash[payload.class] = sections
                this.setState({ sectionDropdownItems: sections, selectedSection: "", reloadSectionDropdown: true }, () => {
                    this.setState({ reloadSectionDropdown: false })
                })
                this.reloadDropdown()
            }).catch(err => {
                this.setState({ sectionDropdownItems: [], selectedSection: "" })
                this.reloadDropdown()
            })
    }

    getChapters(payload = {}) {

        if (!payload.class) payload.class = this.state.selectedClass
        if (!payload.board) payload.board = this.state.selectedBoard

        if (this.state.isFromPk) {
            payload.addNotShowInSchoolChaptersForPK = true
        }

        if (this.user.subjectId === Constants.SCIENCE_SUBJECTID) {
            payload.subSubjectId = this.state.selectedSubSubjectId
        }

        if ((this.props.type === Constants.CLICKER_CONCEPT_CARD && this.state.selectedRevisionType === 'REVISION_WITH_PRACTICE') ||
            (this.props.type === Constants.CLICKER_CONCEPT_CARD && this.state.selectedRevisionType === Constants.ONLY_REVISION)) {
            // payload.isWorksheetChapterList = true // Commented to Get worksheet questions from Primary Masterdata
            payload.conceptCardPdf = true
        }

        if (this.state.selectedRevisionType === 'REVISION_WITH_ASSESSMENT') {
            payload.isClickerAssessment = true
            payload.conceptCardPdf = true
        }


        MasterDataApi.getChapterList(payload)
            .then(response => {
                let chapters = []
                response = response.data
                this.setState({ masterDataId: response._id })
                for (let i = 0; i < response.chapters.length; i++) {
                    let chapter = response.chapters[i], concepts = []
                    chapters.push({
                        title: chapter.title,
                        value: chapter.key,
                    })



                    for (let j = 0; j < chapter.concepts?.length; j++) {
                        let concept = chapter.concepts[j]
                        concepts.push({
                            title: concept.title,
                            value: concept.key,
                            order: j + 1,
                            chapterKey: chapter.key
                        })
                        // this.buildElosDropdown(concept)
                    }
                    this.conceptHash[chapter.key] = concepts

                }

                this.conceptAndChapterKeyHash = {}

                if (this.state.isFromPk) {

                    let hash = this.getChapterKeyForConceptKey()

                    console.log(this.conceptHash)


                    for (let i = 0; i < response.chapters.length; i++) {
                        let chapter = response.chapters[i]
                        console.log(this.conceptHash[this.getChapterKeyForPk()])
                        this.conceptHash[this.getChapterKeyForPk()].forEach(concept => {

                            concept.baseChapterKey = hash[concept.value]

                            // if (concept.title === chapter.title) {
                            //     // Origion Chapter Key
                            //     this.conceptAndChapterKeyHash[concept.value] = chapter.key
                            // }

                        })
                    }
                }

                // console.log(this.conceptAndChapterKeyHash)

                this.setState({ chapterDropDownItems: chapters, selectedElo: "", reloadChapterDropdown: true }, () => {
                    this.setState({ reloadChapterDropdown: false })
                })
                // this.reloadDropdown()
            }).catch(err => {
            })
    }

    getChapterKeyForConceptKey() {

        let hash = {}

        switch (this.state.selectedClass) {
            case 'Class 6':
                hash = {
                    "16533837374847142": "15845131996920700",
                    "16533858012107294": "15856473964482771",
                    "16533859537866169": "15857164729919834",
                    "16533860794669673": "15857164976853655",
                    "16533862257725123": "15857165495906003",
                    "16533863628124282": "15857165661650098",
                    "16533867311374147": "15857165848090445",
                    "16533868102843285": "15857166094719563",
                    "16533868829612973": "15857166437420553",
                    "16533869787154165": "15857166644378707"
                };
                break;
            case 'Class 7':
                hash = {
                    "16533871621566975": "15845144070966249",
                    "16533881394545621": "15856360518110730",
                    "16533883752772603": "15856361122223503",
                    "16533885081008251": "15856361208264022",
                    "16533886374021934": "15856361345562753",
                    "16533887891449037": "15856361596729330",
                    "16533895225638602": "15856361627495437",
                    "16533902524652201": "15856361652486357",
                    "16533907111994765": "15856361747031712",
                    "16533909564324035": "15856361811697076",
                    "16533914238938593": "15856362701104974",
                    "16533915422089716": "15856362826362665",
                    "16533916030612908": "15856363000898741",
                    "16533916081672939": "15856363107929523"
                };
                break;
            case 'Class 8':
                hash = {
                    "16533928739794336": "15857337683614007",
                    "16533934346894248": "15868832020204343",
                    "16533935529353288": "15873071841353333",
                    "16533939949709566": "15873072185461315",
                    "16533950094755221": "15873072390168173",
                    "16533962077391457": "15873072479404585",
                    "16533975927102829": "15873072632957093",
                    "16533977231750042": "15873072719086513",
                    "16533979369062274": "15873072822706766",
                    "16533982570657139": "15873073030008444"
                };
                break;
            case 'Class 9':
                hash = {
                    "16534518035374484": "16252167032887549",
                    "16534518235596193": "16255594624435369",
                    "16534518732721148": "16255595864935652",
                    "16534518933521005": "16255596084001110",
                    "16534518940551071": "16255596226781160",
                    "16534519476447793": "16255597711777661",
                    "16534519779433487": "16255597874627555"
                };
                break;
            default:
                hash = {
                    "16533837374847142": "15845131996920700",
                    "16533858012107294": "15856473964482771",
                    "16533859537866169": "15857164729919834",
                    "16533860794669673": "15857164976853655",
                    "16533862257725123": "15857165495906003",
                    "16533863628124282": "15857165661650098",
                    "16533867311374147": "15857165848090445",
                    "16533868102843285": "15857166094719563",
                    "16533868829612973": "15857166437420553",
                    "16533869787154165": "15857166644378707"
                }
                break;
        }

        return hash

    }

    sortPayload(nodes) {
        let orderedList = [];
        let workFlowNodeHash = {};
        let startingNode;

        for (let i = 0; i < nodes.length; i++) {

            let nodeId = nodes[i]._id.toString();

            if (nodes[i].previousNode == null)
                startingNode = nodeId;

            workFlowNodeHash[nodeId] = nodes[i];
        }

        let tempNode = startingNode;

        for (let i = 0; i < nodes.length; i++) {
            if (tempNode) {
                orderedList.push(workFlowNodeHash[tempNode]);
                tempNode = workFlowNodeHash[tempNode]?.nextNode;
            }
        }
        return orderedList
    }


    getChapterKeyForPk() {

        let chapterKey = ''

        switch (this.state.selectedClass) {
            case 'Class 6':
                chapterKey = '16533836874781844';
                break;
            case 'Class 7':
                chapterKey = "16533871579715896";
                break;
            case 'Class 8':
                chapterKey = "16533917931207385";
                break;
            case 'Class 9':
                chapterKey = "16534517911704106";
                break;
            default:
                chapterKey = '16533836874781844';
                break;

        }

        return chapterKey
    }


    getWorkflowNodes(payload = {}) {
        payload = {
            class: this.state.selectedClass,
            board: this.state.selectedBoard,
            chapterKey: this.state.selectedChapterKey,
            masterDataId: this.state.masterDataId,
            type: this.props.type === 'CLICKER_PRACTICE_STANDARD' || this.props.type === Constants.CLICKER_CONCEPT_CARD ? 'DEFAULT' : 'DEFAULT'
        }

        if (this.props.type === 'CLICKER_PRACTICE_STANDARD' || this.props.type === Constants.CLICKER_CONCEPT_CARD) {
            payload.subBoard = 'WORKSHEET'
        }


        if (this.state.isFromPk) {
            payload.chapterKey = this.getChapterKeyForPk()
        }

        MasterDataApi.getWorkflowNodes(payload)
            .then(response => {
                let workflowId = response.workflowId
                response = response.data

                this.eloHash = {}
                for (let i = 0; i < response.length; i++) {
                    let chapter = response[i], elos = []

                    for (let j = 0; j < chapter.elos?.length; j++) {
                        let elo = chapter.elos[j]
                        elos.push({
                            title: elo.title,
                            value: elo.id,
                            conceptTitle: chapter.conceptTitle,
                            conceptValue: chapter.conceptKey,
                            skill: elo.skill?.title
                        })
                    }
                    if (this.eloHash[chapter.conceptKey]) {
                        this.eloHash[chapter.conceptKey].push(...elos)
                    } else {
                        this.eloHash[chapter.conceptKey] = elos
                    }
                }

                let eloList = this.sortPayload(response)
                console.log(response.workflowId)
                this.setState({ orderedEloList: eloList, workflowId }, () => {
                    this.onMultiSelectDropdown(this.state.conceptDropownItems, 'selectedConcept')
                })
            }).catch(err => {
                this.emitChanges()
            })
    }

    buildElosDropdown(concept) {
        let elos = []
        for (let i = 0; i < concept?.subConcepts?.length; i++) {
            let subConcept = concept.subConcepts[i]
            for (let j = 0; j < subConcept.elo?.length; j++) {
                let elo = subConcept.elo[j]
                elos.push({
                    title: elo.title,
                    value: elo.eloId,
                    conceptTitle: concept.title,
                    conceptValue: concept.key
                })
            }

        }
        this.eloHash[concept.key] = elos
        return
    }

    reloadDropdown() {
        this.setState({ reloadDropdown: true }, () => {
            this.setState({ reloadDropdown: false })
        })
    }

    resetDropDowns(callback) {

        this.setState({
            selectedBoardId: "",
            selectedClassId: "",
            chapterDropdownItems: [],


        }, () => { if (callback) callback(); });
    }


    onGo() {
        let payload = {
            board: this.state.selectedBoard,
            class: this.state.selectedClass,
            chapterKey: this.state.selectedChapterKey,
            assignedTo: this.state.selectedTeachersId
        };
        if (this.props.onGo) {
            this.props.onGo(payload)
        }
    }

    refreshPage() {
        this.setState(
            { reload: true },
            () => this.setState({ reload: false })
        )
    }

    toggleFilters = () => {
        this.setState({ showFilters: !this.state.showFilters })
    }

    onSelectDropDown = (option, key) => {
        console.log(option, key)

        this.setState({ [key]: option?.value, }, () => {
            this.props.delegate && this.props.delegate.resetErrorMessages && this.props.delegate.resetErrorMessages()

            if (key == 'selectedSubSubjectId') {
                this.setState({ subSubjectName: option?.title, selectedChapterKey: [], selectedConcept: [] }, () => {
                    this.resetDropDownsForRevision()
                })
            }

            if (key == "selectedClass" || key == "selectedBoard") {
                if (option?.value) {
                    this.getSections()
                    this.getChapters()
                }
            }

            if (key == 'selectedSection') {
                // console.log(option?.title)
                this.setState({ [key]: option?.sectionId, sectionTitle: option?.title })
            }

            // if (key == "selectedChapterKey") {

            //     this.setState({ selectedConcept: "" })

            //     if (option?.value) {
            //         this.getWorkflowNodes()

            //         console.log(this.conceptHash)

            //         if (this.state.selectedChapterKey === option?.value) {

            //             if (this.state.isFromPk) {
            //                 let chapterKey = option.title ? option.title : this.props.delegate?.props?.delegate?.props?.delegate?.props?.location?.state?.homeworkAssignPayload?.chapterKey ? this.props.delegate?.props?.delegate?.props?.delegate?.props?.location?.state?.homeworkAssignPayload?.chapterKey : ''
            //                 console.log(chapterKey)
            //                 let concept = this.conceptHash[this.getChapterKeyForPk()].filter(item => item.baseChapterKey === chapterKey)
            //                 console.log(concept)
            //                 this.setState({ conceptDropownItems: concept, pkConceptKey: concept[0].value ? concept[0].value : '', reloadConceptDropdown: true }, () => {
            //                     this.setState({ reloadConceptDropdown: false })
            //                     // this.emitChanges()
            //                 })
            //             } else {
            //                 this.setState({ conceptDropownItems: this.conceptHash[option?.value], reloadConceptDropdown: true }, () => {
            //                     this.setState({ reloadConceptDropdown: false })
            //                     // this.emitChanges()
            //                 })
            //             }



            //         } else {
            //             this.setState({ conceptDropownItems: this.conceptHash[option?.value], reloadConceptDropdown: true, }, () => {
            //                 this.setState({ reloadConceptDropdown: false })
            //                 // this.emitChanges()
            //             })
            //         }

            //     } else {
            //         this.setState({ conceptDropownItems: [], reloadConceptDropdown: true, }, () => {
            //             this.setState({ reloadConceptDropdown: false })

            //         })
            //     }
            //     this.reloadDropdown()
            // }

            if (key == "selectedConcept") {
                let eloDropdownItems = [], conceptList = [], skillDropdownItems = [], skillHash = {}
                if (this.eloHash[option?.value]) {

                    let eloContruct = []
                    let elo = this.eloHash[option?.value]
                    let elos = elo.map((e) => {

                        if (!skillHash[e.skill]) {
                            skillHash[e.skill] = true
                            skillDropdownItems.push({ title: e.skill, value: e.skill })
                        }

                        eloContruct.push({ id: e.value })
                        return {
                            ...e,
                            conceptName: `Concept 1`
                        }
                    })
                    eloDropdownItems.push(...elos)

                    conceptList.push({
                        key: option?.value,
                        elos: eloContruct
                    })
                }



                this.setState({ eloDropdownItems, skillDropdownItems, conceptList, conceptsArray: conceptList }, () => {
                    this.props.delegate?.handleEloDropdown && this.props.delegate.handleEloDropdown(eloDropdownItems, skillDropdownItems, conceptList)
                    this.emitChanges()
                })
            }


            this.emitChanges(key == "selectedClass" || key == "selectedBoard" || key == "selectedSection" || key == 'selectedSubSubjectId')
        })
    }


    onSelectSection = (options, isMannual = false) => {
        let values = options.map(option => option?.value)

        this.setState({ selectedSection: values }, () => {
            this.setState({})
            this.emitChanges(true)
        })
    }

    onMultiSelectDropdown = (options, key, isMannual = false) => {
        console.log(options, key)

        if (this.state.isFromPk) {
            options = [{ value: this.state.pkConceptKey, order: 1 }]
        }

        this.props.delegate && this.props.delegate.resetErrorMessages && this.props.delegate.resetErrorMessages()
        let value = [], eloDropdownItems = [], conceptList = [], skillDropdownItems = [], skillHash = {}, selectedElo = []
        options = options.sort((a, b) => a.order - b.order)
        console.log(this.eloHash)

        for (let i = 0; i < options.length; i++) {
            let option = options[i]
            value.push(option?.value)

            if (key == "selectedConcept") {
                if (this.eloHash[option?.value]) {
                    console.log('selected Concept')
                    let eloContruct = []
                    let elo = this.eloHash[option?.value]
                    let elos = elo.map((e) => {

                        if (!skillHash[e.skill]) {
                            skillHash[e.skill] = true
                            skillDropdownItems.push({ title: e.skill, value: e.skill })
                        }

                        eloContruct.push({ id: e.value })

                        selectedElo.push(e.value) // To Select All the Elo


                        return {
                            ...e,
                            conceptName: `Concept ${i + 1}`
                        }
                    })
                    eloDropdownItems.push(...elos)

                    conceptList.push({
                        key: option?.value,
                        elos: eloContruct
                    })
                }
            }
        }
        // let selectedElo = eloDropdownItems.map(item => item.value)
        // console.log(value)

        // console.log(selectedElo)

        let reloadConceptDropdown = true

        if (isMannual) {
            reloadConceptDropdown = false
        }

        if (this.props.isFromDraft) {
            reloadConceptDropdown = true
        }
        this.setState({ reloadDropdown: true, reloadConceptDropdown, eloDropdownItems, skillDropdownItems, [key]: value, conceptList, conceptsArray: conceptList, selectedElo }, () => {
            this.props.isAdaptive && key == "selectedConcept" && this.props.delegate?.handleEloDropdown && this.props.delegate.handleEloDropdown(eloDropdownItems, skillDropdownItems, conceptList)
            if (this.props.isClonePractice && !isMannual) {
                this.setState({ reloadDropdown: false, reloadConceptDropdown: false })
            } else if (isMannual) {
                this.setState({ reloadDropdown: false })
            } else if (!isMannual) {
                this.setState({ reloadDropdown: false, reloadConceptDropdown: false })
            }

            this.emitChanges()
        })
    }


    onMultiSelectDropdownForChapter = (options, key, isMannual = false) => {
        console.log(options, key)
        if (options && Object.keys(options).length) {
            options = [options] // If you want multiple Chapter Change the Drop down to DropdownV4 with Multi Select true and Remove the Array Bracket, then it will work for multiple chapter
        } else {
            options = []
        }
        let value = [], selectedConceptDropownItems = []
        for (let i = 0; i < options.length; i++) {
            let option = options[i]
            value.push(option?.value)
            if (this.conceptHash[option?.value]) {
                selectedConceptDropownItems.push(...this.conceptHash[option?.value])
            }
        }

        console.log(selectedConceptDropownItems, value)
        let reloadChapterDropdown = false
        if (isMannual) {
            reloadChapterDropdown = true
        }


        this.setState({ [key]: value, selectedChapter: options, reloadChapterDropdown }, () => {
            this.setState({ reloadChapterDropdown: false })
            if (this.state.selectedRevisionType === Constants.REVISION_WITH_ASSESSMENT) {
                this.getQuestionSet()
            } else {
                this.getWorkflowNodes()
                this.setState({ conceptDropownItems: selectedConceptDropownItems, reloadConceptDropdown: true, }, () => {
                    this.setState({ reloadConceptDropdown: false })
                    if (isMannual) {
                    } else {
                        this.emitChanges()
                    }

                })
                this.reloadDropdown()
            }
        })
    }

    getQuestionSet() {

        let chapters = []

        if (this.state.selectedChapter && this.state.selectedChapter?.length) {
            chapters = this.state.selectedChapter?.map(item => {
                return item.value
            })
        }

        console.log(this.state.selectedChapter, chapters.join(','))

        if (!chapters.length) return;

        let payload = {
            chapterKey: chapters.join(','),
            class: this.state.selectedClass?.value
        }

        // console.log('called question set')

        payload.type = this.props.type


        TestApi.getQuestionSet(payload).then(response => {
            console.log(response)

            let questionSetDropdownItems = []
            let homeworkCreatedQuestionCategoryHash = response.homeworkCreatedQuestionCategoryHash

            response.questionSetIdsList.forEach((item, index) => {
                let obj = {
                    title: `Set ${index + 1}`,
                    value: item,
                    isAlreadyHomeworkCreated: homeworkCreatedQuestionCategoryHash[item] ? true : false
                }

                questionSetDropdownItems.push(obj)

            })

            if (questionSetDropdownItems && questionSetDropdownItems.length === 1) {
                this.setState({ questionSetDropdownItems, reloadQuestionSetDropdown: true }, () => {
                    this.setState({ reloadQuestionSetDropdown: false })
                    this.onSelectQuestionSet(questionSetDropdownItems[0])
                })
            } else {
                this.setState({ questionSetDropdownItems, reloadQuestionSetDropdown: true }, () => {
                    this.setState({ reloadQuestionSetDropdown: false })
                })
            }

        }).catch(err => {
            console.log(err)
        })
    }

    onSelectQuestionSet(option) {
        // console.log(option)

        let showHomeworkAlreadyCreatedForSetPopup = false

        if (option?.isAlreadyHomeworkCreated) {
            showHomeworkAlreadyCreatedForSetPopup = true
        }



        if (this.state.questionSetDropdownItems && this.state.questionSetDropdownItems.length > 1 && showHomeworkAlreadyCreatedForSetPopup) {
            this.setState({ selectedQuestionSetId: option?.value, selectedQuestionSetTitle: option?.title, showHomeworkAlreadyCreatedForSetPopup }, () => {

            })
        } else {
            this.setState({ selectedQuestionSetId: option?.value, selectedQuestionSetTitle: option?.title }, () => {
                this.emitChanges(true)
            })
        }
    }

    onSelectElo = (options) => {
        let groupByConcept = {}
        let conceptList = [], chapters = {}

        for (let i = 0; i < options.length; i++) {
            let option = options[i]

            if (!groupByConcept[option?.conceptValue])
                groupByConcept[option.conceptValue] = { key: option.conceptValue, elos: [{ id: option?.value }] }
            else
                groupByConcept[option.conceptValue].elos.push({
                    id: option?.value
                })
        }

        // let conceptKeys = Object.keys(groupByConcept)

        let conceptKeys = []

        for (let i = 0; i < this.state.conceptsArray.length; i++) {

            conceptKeys.push(this.state.conceptsArray[i].key)
        }

        // console.log(chapters)

        for (let i = 0; i < conceptKeys.length; i++) {

            let key = conceptKeys[i]
            if (groupByConcept[key]) {
                conceptList.push({
                    key,
                    elos: groupByConcept[key].elos
                })
            }

        }

        let values = options.map(option => option?.value)


        let reloadDropdown = false

        if (this.props.isFromDraft) {
            reloadDropdown = true
        }

        console.log(values)

        this.setState({ selectedElo: values, conceptList, reloadDropdown }, () => {
            this.setState({ reloadDropdown: false })
            this.emitChanges()
        })
    }

    handleDateEvent = (event, picker) => {
        this.props.delegate && this.props.delegate.resetErrorMessages && this.props.delegate.resetErrorMessages()
        this.startDate = picker.startDate
        this.setState({ selectedDate: new Date(picker.startDate).toLocaleDateString() });
        this.emitChanges(true, false)
    }


    emitChanges(reloadStudent, isReloadQuestions = true) {
        //console.log('chapter filter called')


        let payload = {
            board: this.state.selectedBoard,
            class: this.state.selectedClass,
            section: this.state.sectionTitle,
            sectionId: this.state.selectedSection,
            chapter: this.state.selectedChapterKey,
            concepts: this.state.selectedConcept,
            selectedElo: this.state.selectedElo,
            elos: this.state.selectedElo,
            dueDate: this.startDate ? (new Date(new Date(this.startDate).setHours(23, 59, 59, 999)).toISOString()).slice(0, -1) : '',
            masterDataId: this.state.masterDataId,
            conceptList: this.state.conceptList,
            homeworkId: this.state.selectedStandardHomeworkId || this.state.recommendationReportHomeworkId,
            showTimer: this.state.showTimer,
            showLeaderboard: this.state.showLeaderboard,
            leaderboardLimit: this.state.leaderboardLimit,
            eloDropdownItems: this.state.eloDropdownItems,
            conceptDropownItems: this.state.conceptDropownItems,
            skillDropdownItems: this.state.skillDropdownItems,
            conceptsArray: this.state.conceptsArray,
            assignFrom: this.state.assignFrom
        }

        if (payload.sectionId) {
            payload.section = this.sectionHash
        }

        if (this.state.recommendationReportHomeworkId) {
            payload.assignFrom = "REMEIDAL_REPORT"
        }

        if (this.user.subjectId === Constants.SCIENCE_SUBJECTID) {
            payload.subSubjectId = this.state.selectedSubSubjectId
            payload.subSubjectName = this.state.subSubjectName
        }

        if (this.state.assigningFrom) {
            payload.assigningFrom = this.state.assigningFrom
        }

        if (this.props.type === Constants.CLICKER_CONCEPT_CARD) {
            payload.revisionType = this.state.selectedRevisionType
            payload.autoNext = this.state.autoNext
            payload.schoolId = this.user.schoolInfo.schoolCode

            if (this.state.selectedRevisionType === Constants.REVISION_WITH_ASSESSMENT) {
                let chapters = []

                if (this.state.selectedChapter && this.state.selectedChapter?.length) {
                    chapters = this.state.selectedChapter?.map(item => {
                        return {
                            key: item.value,
                            title: item.title
                        }
                    })
                }

                payload.chapters = chapters
                if (this.state.selectedChapter && this.state.selectedChapter?.length === 1) {
                    payload.selectedQuestionSetId = this.state.selectedQuestionSetId
                    payload.selectedQuestionSetTitle = this.state.selectedQuestionSetTitle
                }

            }
        }

        if (payload.chapter && !payload.chapter.length) {
            payload.eloDropdownItems = []
            payload.skillDropdownItems = []
        }


        if (this.state.isFromPk) {
            payload.pkChapterKey = this.getChapterKeyForPk()
            payload.chapterTitle = this.props.delegate?.props?.delegate?.props?.delegate?.props?.location?.state?.homeworkAssignPayload?.chapterTitle
        }

        if (this.props.isFromDraft) {
            payload.draftHomeworkId = this.props.selectedHomework._id
            // payload.cwPracticeNumber = this.props.selectedHomework.cwPracticeNumber
        }

        if (this.state.createDraft) {
            payload.createDraft = true
        }

        if (this.props.isFinishLine) {
            payload.baseLineHomeworkId = this.props.selectedHomework._id
        }

        if (this.state.selectedClass === 'Class 10') {
            payload.assessmentQuestionType = this.state.assessmentQuestionType
            payload.questionCategory = this.state.selectedQuestionSet
            payload.selectedQuestionSetTitle = this.state.selectedQuestionSetTitle
        }


        if (this.props.onGo) {
            this.props.onGo(payload, reloadStudent, isReloadQuestions)
        }



    }

    setStatus(status) {
        if (status === 'TIMER') {
            this.setState({ showTimer: !this.state.showTimer }, () => {
                this.emitChanges()
            })
        }

        if (status === 'LEADERBOARD') {
            this.setState({ showLeaderboard: !this.state.showLeaderboard }, () => {
                this.emitChanges()
            })
        }

        if (status === 'AUTO_NEXT') {
            this.setState({ autoNext: !this.state.autoNext }, () => {
                this.emitChanges()
            })
        }
    }



    setLeaderboardLimit(limit) {
        this.setState({ leaderboardLimit: limit }, () => {
            this.emitChanges()
        })
    }

    changeHomeworkType() {
        this.setState({ createDraft: !this.state.createDraft }, () => {
            this.emitChanges()
        })
    }

    setAssessmentQuestionType(option, key, type) {
        this.setState({ assessmentQuestionType: type, [key]: option?.value }, () => {
            // this.emitChanges()
            this.getChapterQuestionTypeSetInfo(type)
        })
    }

    getChapterQuestionTypeSetInfo(type) {
        let payload = {
            workflowId: this.state.workflowId,
            chapterKey: this.state.selectedChapterKey,
            masterDataId: this.state.masterDataId,
            type
        }

        HomeworkApi.getChapterQuestionTypeSetInfo(payload).then(response => {
            console.log(response)

            let questionSetDropdownItems = []

            let questionCategory = response.questionCategory
            let homeworkCreatedQuestionCategoryHash = response.homeworkCreatedQuestionCategoryHash

            questionCategory = questionCategory.sort();

            questionCategory.forEach((item, index) => {
                let obj = {
                    title: `Set ${index + 1}`,
                    value: item,
                    isAlreadyHomeworkCreated: homeworkCreatedQuestionCategoryHash[item] ? true : false
                }
                questionSetDropdownItems.push(obj)
            })

            if (questionSetDropdownItems && questionSetDropdownItems.length === 1) {
                this.setState({ questionSetDropdownItems, reloadQuestionSetDropdown: true }, () => {
                    this.setState({ reloadQuestionSetDropdown: false })
                    this.onSelectedSet(questionSetDropdownItems, 'selectedQuestionSet')
                })
            } else {
                this.setState({ questionSetDropdownItems, reloadQuestionSetDropdown: true }, () => {
                    this.setState({ reloadQuestionSetDropdown: false })
                })
            }

        }).catch(err => {
            console.log(err)
        })

    }

    onSelectedSet(options, key) {
        console.log(options, key)
        let value = []
        let seletedSetsTitles = []

        let showHomeworkAlreadyCreatedForSetPopup = false

        for (let i = 0; i < options.length; i++) {
            let option = options[i]
            value.push(option?.value)
            seletedSetsTitles.push(option?.title)
            if (option.isAlreadyHomeworkCreated) {
                showHomeworkAlreadyCreatedForSetPopup = true
            }
        }

        if (this.state.questionSetDropdownItems && this.state.questionSetDropdownItems.length > 1 && showHomeworkAlreadyCreatedForSetPopup) {

            this.setState({ [key]: value, selectedQuestionSetTitle: seletedSetsTitles, showHomeworkAlreadyCreatedForSetPopup }, () => {

            })

        } else {
            this.setState({ [key]: value, selectedQuestionSetTitle: seletedSetsTitles }, () => {
                this.emitChanges()
            })
        }


    }

    onOk() {
        this.setState({ showHomeworkAlreadyCreatedForSetPopup: false })
        this.emitChanges()
    }

    cancelPopup() {

        let selectedQuestionSet = this.state.selectedQuestionSet
        let selectedQuestionSetTitle = this.state.selectedQuestionSetTitle

        selectedQuestionSet.pop()
        selectedQuestionSetTitle.pop()
        // console.log(selectedQuestionSet)
        this.setState({
            showHomeworkAlreadyCreatedForSetPopup: false, selectedQuestionSet,
            selectedQuestionSetTitle
        }, () => {
            // this.setState({reloadQuestionSetDropdown : false})
        })

    }

    resetDropDownsForRevision() {
        this.setState({ selectedClass: '', selectedSection: [], selectedChapterKey: [], conceptDropownItems: [], chapterDropDownItems: [], reloadDropdown: true, reloadSectionDropdown: true, reloadChapterDropdown: true }, () => {
            this.setState({ reloadDropdown: false, reloadSectionDropdown: false, reloadChapterDropdown: false })
            this.emitChanges()
        })
    }

    setSelectedRevisionType(type) {
        if (this.state.selectedRevisionType === type) {
            this.setState({ selectedRevisionType: 'ONLY_REVISION' })
            this.emitChanges()
        } else {
            this.setState({ selectedRevisionType: type }, () => {
                this.resetDropDownsForRevision()

            })
        }
    }



    render() {

        return (

            <div className="new-homwwork-filter-for-clicker-v2">
                {
                    !this.state.reload ?
                        <div className={this.state.showFilters ? "filter-content" : "filter-content d-none"} >
                            <div className="row">

                                {
                                    this.props.type === Constants.CLICKER_CONCEPT_CARD ?
                                        <div className='col-lg-2 col-md-3 col-sm-12 pt-4'>
                                            <div className="filter-input-label">
                                                With
                                            </div>
                                            <div className='d-flex flex-column ml-3'>
                                                <div className='d-flex align-items-center cursor-pointer' onClick={() => this.setSelectedRevisionType('REVISION_WITH_PRACTICE')}>
                                                    <div className='outer-circle d-flex align-items-center justify-content-center'>
                                                        {this.state.selectedRevisionType === 'REVISION_WITH_PRACTICE' ? <div className='inner-circle'></div> : ''}
                                                    </div>
                                                    <div className='ml-2'>Practice</div>
                                                </div>
                                                <div className='d-flex  align-items-center cursor-pointer' onClick={() => this.setSelectedRevisionType('REVISION_WITH_ASSESSMENT')}>
                                                    <div className='outer-circle d-flex align-items-center justify-content-center'>
                                                        {this.state.selectedRevisionType === 'REVISION_WITH_ASSESSMENT' ? <div className='inner-circle'></div> : ''}
                                                    </div>
                                                    <div className='ml-2'>Assessment</div>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <></>
                                }

                                {
                                    this.state.boardsDropdownItems.length > 1 ?
                                        <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                            <div className="filter-input-label">
                                                Board<span className='text-danger'>*</span>
                                            </div>
                                            <div className={this.props.isCreate && !this.state.selectedBoard ? 'error-border' : ''}>
                                                <Dropdown
                                                    placeholder='Select a board'
                                                    options={this.state.boardsDropdownItems}
                                                    onSelect={(option) => this.onSelectDropDown(option, "selectedBoard")}
                                                    text={"title"}
                                                    value={this.state.selectedBoard}

                                                />
                                            </div>
                                            {this.props.isCreate && !this.state.selectedBoard ? <div className='error-text text-danger'>Please Select a board</div> : ''}
                                        </div>
                                        : ""
                                }

                                {
                                    this.user.subjectId === Constants.SCIENCE_SUBJECTID ?
                                        <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                            <div className="filter-input-label">
                                                Subjects<span className='text-danger'>*</span>
                                            </div>
                                            <div className={this.props.isCreate && !this.state.selectedSubSubjectId ? 'error-border' : ''}>
                                                <Dropdown
                                                    placeholder='Select a Subject'
                                                    options={this.state.subSubjectsDropDownItems}
                                                    onSelect={(option) => this.onSelectDropDown(option, "selectedSubSubjectId")}
                                                    text={"title"}
                                                    value={this.state.selectedSubSubjectId}

                                                />
                                            </div>
                                            {this.props.isCreate && !this.state.selectedSubSubjectId ? <div className='error-text text-danger'>Please Select a board</div> : ''}
                                        </div>
                                        :
                                        <></>
                                }


                                <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                    <div className="filter-input-label">
                                        Class<span className='text-danger'>*</span>
                                    </div>
                                    <div className={this.props.isCreate && !this.state.selectedClass ? 'error-border' : ''}>
                                        {!this.state.reloadDropdown ?
                                            <Dropdown
                                                placeholder='Select a Class'
                                                options={this.state.classDropdownItems}
                                                onSelect={(option) => this.onSelectDropDown(option, "selectedClass")}
                                                text={"title"}
                                                value={this.state.selectedClass}
                                            /> : ''}
                                    </div>
                                    {this.props.isCreate && !this.state.selectedClass ? <div className='error-text text-danger'>Please Select a class</div> : ''}
                                </div>
                                <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                    <div className="filter-input-label">
                                        Section<span className='text-danger'>*</span>
                                    </div>
                                    <div className={this.props.isCreate && !this.state.selectedSection ? 'error-border' : ''}>
                                        {
                                            !this.state.reloadSectionDropdown ?
                                                <DropdownV4
                                                    key="section-multi"
                                                    placeholder='Select a Section'
                                                    options={this.state.sectionDropdownItems}
                                                    onSelect={(option) => this.onSelectSection(option, true)}
                                                    text={"title"}
                                                    multiSelect={true}
                                                    value={this.state.selectedSection}
                                                >
                                                </DropdownV4>
                                                : ""
                                        }
                                    </div>
                                    {this.props.isCreate && !this.state.selectedSection ? <div className='error-text text-danger'>Please Select a Section</div> : ''}
                                </div>
                                <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                    <div className="filter-input-label">
                                        Chapter<span className='text-danger'>*</span>
                                    </div>
                                    <div className={this.props.isCreate && !this.state.selectedChapterKey ? 'error-border' : ''}>
                                        {!this.state.reloadChapterDropdown ?
                                            <Dropdown
                                                placeholder='Select Chapter'
                                                options={this.state.chapterDropDownItems}
                                                onSelect={(option) => this.onMultiSelectDropdownForChapter(option, "selectedChapterKey")}
                                                text={"title"}
                                                value={this.state.selectedChapterKey && this.state.selectedChapterKey.length ? this.state.selectedChapterKey[0] : ''}
                                                disabled={this.props.delegate?.props?.delegate?.props?.delegate?.props?.location?.state?.homeworkAssignPayload?.forWhat === 'PREVIOUS_KNOWLEDGE'}
                                            >
                                            </Dropdown>
                                            // <DropdownV4
                                            //     key="chapter-multi"
                                            //     placeholder='Select Chapter'
                                            //     // multiSelect={true}
                                            //     options={this.state.chapterDropDownItems}
                                            //     onSelect={(option) => this.onMultiSelectDropdownForChapter(option, "selectedChapterKey")}
                                            //     text={"title"}
                                            //     value={this.state.selectedChapterKey && this.state.selectedChapterKey.length ? this.state.selectedChapterKey[0]: ''}
                                            //     disabled={this.props.delegate?.props?.delegate?.props?.delegate?.props?.location?.state?.homeworkAssignPayload?.forWhat === 'PREVIOUS_KNOWLEDGE'}
                                            // >
                                            // </DropdownV4> 
                                            : ''
                                        }
                                    </div>
                                    {this.props.isCreate && !this.state.selectedChapterKey ? <div className='error-text text-danger'>Please Select a Chapter</div> : ''}
                                </div>



                                {
                                    // (
                                    // ||
                                    // this.props.type === 'CLICKER_PRACTICE_STANDARD' ||
                                    // (this.props.type === Constants.CLICKER_CONCEPT_CARD && this.state.selectedRevisionType === Constants.REVISION_WITH_PRACTICE)) ?
                                    this.props.type == "ADAPTIVE_CLASSWORK" ?
                                        <>
                                            <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                                <div className="filter-input-label">
                                                    Concept<span className='text-danger'>*</span>
                                                </div>
                                                <div className={this.props.isCreate && !this.state.selectedConcept ? 'error-border' : ''}>
                                                    {
                                                        !this.state.reloadConceptDropdown ?
                                                            <DropdownV4
                                                                key="concept-multi"
                                                                placeholder='Select a Concept'
                                                                options={this.state.conceptDropownItems}
                                                                onSelect={(option) => this.onMultiSelectDropdown(option, 'selectedConcept', true)}
                                                                text={"title"}
                                                                multiSelect={true}
                                                                value={this.state.selectedConcept}

                                                            />
                                                            : ""
                                                    }
                                                </div>
                                                {this.props.isCreate && !this.state.selectedConcept ? <div className='error-text text-danger'>Please Select a concept</div> : ''}
                                            </div>
                                            {
                                                this.props.type === "ADAPTIVE_CLASSWORK" ?
                                                    <></>
                                                    :
                                                    <></>
                                                // <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                                //     <div className="filter-input-label">
                                                //         Learning Outcome
                                                //     </div>
                                                //     <div>
                                                //         {
                                                //             !this.state.reloadDropdown ?
                                                //                 <DropdownV4
                                                //                     key="learning"
                                                //                     placeholder='Select learning outcomes'
                                                //                     options={this.state.eloDropdownItems}
                                                //                     onSelect={(option) => this.onSelectElo(option)}
                                                //                     value={this.state.selectedElo}
                                                //                     text={"title"}
                                                //                     multiSelect
                                                //                     isFilter
                                                //                     filterKey="skill"
                                                //                     filterItem={this.state.skillDropdownItems}
                                                //                     filterTitle="SKILL FILTERS"
                                                //                     isLocalSearch
                                                //                 />
                                                //                 : ""
                                                //         }
                                                //     </div>
                                                // </div>
                                            }

                                        </>
                                        : ""
                                }

                                {/* {
                                    (this.props.type != 'CLICKER_PRACTICE_STANDARD' && this.props.type != Constants.CLICKER_CONCEPT_CARD) && this.state.selectedClass === 'Class 10' ?
                                        <>
                                            <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                                <div className="filter-input-label">
                                                    Question Type<span className='text-danger'>*</span>
                                                </div>
                                                <div className={this.props.isCreate && !this.state.selectedAssessmentQuestionTypeId ? 'error-border' : ''}>
                                                    {
                                                        !this.state.reloadQuestionTypeDropdown ?
                                                            <Dropdown
                                                                key="concept-multi"
                                                                placeholder='Select a Question Type'
                                                                options={this.state.assessmentQuestionTypeDropDownItems}
                                                                onSelect={(option) => this.setAssessmentQuestionType(option, 'selectedAssessmentQuestionTypeId', option?.title)}
                                                                text={"title"}
                                                                value={this.state.selectedAssessmentQuestionTypeId}

                                                            />
                                                            : ""
                                                    }
                                                </div>
                                                {this.props.isCreate && !this.state.selectedAssessmentQuestionTypeId ? <div className='error-text text-danger'>Please Select a Question Type</div> : ''}
                                            </div>
                                            {
                                                this.state.questionSetDropdownItems && this.state.questionSetDropdownItems.length > 1 ?
                                                    <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                                        <div className="filter-input-label">
                                                            Question Set<span className='text-danger'>*</span>
                                                        </div>
                                                        <div className={this.props.isCreate && !this.state.selectedQuestionSet ? 'error-border' : ''}>
                                                            {
                                                                !this.state.reloadQuestionSetDropdown ?
                                                                    <DropdownV4
                                                                        key="concept-multi"
                                                                        placeholder='Select a Question Set'
                                                                        options={this.state.questionSetDropdownItems}
                                                                        onSelect={(option) => this.onSelectedSet(option, 'selectedQuestionSet')}
                                                                        text={"title"}
                                                                        multiSelect={true}
                                                                        value={this.state.selectedQuestionSet}
                                                                    />
                                                                    : ""
                                                            }
                                                        </div>
                                                        {this.props.isCreate && !this.state.selectedQuestionSet ? <div className='error-text text-danger'>Please Select a Question Set</div> : ''}
                                                    </div>
                                                    :
                                                    <></>
                                            }

                                        </>
                                        :
                                        <></>
                                } */}

                                {
                                    this.state.selectedRevisionType === Constants.REVISION_WITH_ASSESSMENT && this.state.selectedChapter &&
                                        this.state.selectedChapter.length === 1 &&
                                        this.state.questionSetDropdownItems && this.state.questionSetDropdownItems.length > 1 ?

                                        <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                            <div className="filter-input-label">
                                                Question Set<span className='text-danger'>*</span>
                                            </div>
                                            <div className={this.props.isCreate && !this.state.selectedQuestionSetId ? 'error-border' : ''}>
                                                {!this.state.reloadQuestionSetDropdown ?
                                                    <Dropdown
                                                        placeholder='Select Question Set'
                                                        options={this.state.questionSetDropdownItems}
                                                        onSelect={(option) => this.onSelectQuestionSet(option)}
                                                        text={"title"}
                                                        value={this.state.selectedQuestionSetId}
                                                    // disabled={this.props.delegate?.props?.delegate?.props?.delegate?.props?.location?.state?.homeworkAssignPayload?.forWhat === 'PREVIOUS_KNOWLEDGE'}
                                                    >
                                                    </Dropdown>
                                                    : ''
                                                }
                                            </div>
                                            {this.props.isCreate && !this.state.selectedQuestionSetId ? <div className='error-text text-danger'>Please Select a Question Set</div> : ''}
                                        </div>
                                        :
                                        <></>
                                }


                                {
                                    this.props.type != 'CLICKER_PRACTICE_STANDARD' && this.props.type != Constants.CLICKER_CONCEPT_CARD ?
                                        <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                            <div className="filter-input-label" >
                                                Due Date<span className='text-danger'>*</span>
                                            </div>
                                            <div className={this.props.isCreate && !this.state.selectedDate ? 'error-border' : ''}>
                                                <DateRangePicker onHide={this.handleDateEvent} onCancel={() => { }}
                                                    autoApply={true}
                                                    initialSettings={{ singleDatePicker: true, startDate: this.startDate, minDate: this.startDate ? this.startDate : new Date(), autoUpdateInput: false }}
                                                    locale={{
                                                        'format': 'DD/MM/YYYY'
                                                    }}

                                                ><input className={`cw-input ${!this.props.selectDueDateMessage ? 'bg-white' : ""} `} style={{ border: '1px solid #4BC3C6' }} placeholder="Select date" value={this.state.selectedDate} ></input>
                                                </DateRangePicker>
                                            </div>
                                            {this.props.isCreate && !this.state.selectedDate ? <div className='error-text text-danger'>Please Select a due date</div> : ''}
                                        </div>
                                        :
                                        <></>
                                }


                                {/* {
                                    this.props.type === 'CLICKER_PRACTICE_STANDARD' ?
                                        !this.props.isFromDraft ?
                                            <>
                                                {
                                                    <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                                        <div className='d-flex align-items-center ml-1 status-wrapper'>
                                                            <div className='d-flex align-items-center cursor-pointer justify-content-center' onClick={() => this.changeHomeworkType()}>
                                                                {
                                                                    this.state.createDraft ? <div className="active-check-box">
                                                                        <img className="green-tick-icon" src={getImageSource(ImageConstants.GREEN_CHECK_BOX)} />
                                                                    </div>
                                                                        :
                                                                        <div className="">
                                                                            <img className="gray-tick-icon" src={getImageSource(ImageConstants.GRAY_CHECK_BOX)} />
                                                                        </div>
                                                                }
                                                            </div>
                                                            <div className="filter-input-label-for-draft mt-2">
                                                                Draft
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                            </>
                                            :
                                            <></>

                                        :
                                        <></>

                                } */}
                            </div>

                            {
                                this.state.selectedRevisionType === Constants.REVISION_WITH_ASSESSMENT ?
                                    <div className='row'>
                                        <div className="col-lg-12 col-md-6 col-sm-12 d-flex">
                                            <div className='d-flex align-items-center ml-3 status-wrapper'>
                                                <div className='d-flex align-items-center cursor-pointer justify-content-center' onClick={() => this.setStatus('AUTO_NEXT')}>
                                                    {
                                                        this.state.autoNext ? <div className="active-check-box">
                                                            <img className="green-tick-icon" src={getImageSource(ImageConstants.GREEN_CHECK_BOX)} />
                                                        </div>
                                                            :
                                                            <div className="">
                                                                <img className="gray-tick-icon" src={getImageSource(ImageConstants.GRAY_CHECK_BOX)} />
                                                            </div>
                                                    }
                                                </div>
                                                <div className="timer-wrapper-for-timer d-flex align-items-center">
                                                    <img className='timer-image-for-auto-next pl-2' src={getImageSource(ImageConstants.BLOCK_TIMER)} />
                                                    <span className='timer-text pl-2'>Automatically Move to Next Question</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <></>
                            }

                            {
                                this.props.type === 'CLICKER_PRACTICE_STANDARD' ||

                                    (this.props.type === Constants.CLICKER_CONCEPT_CARD && this.state.selectedRevisionType === Constants.REVISION_WITH_PRACTICE) ?
                                    <>
                                        {/* <div className='row'>
                                            <div className="col-lg-3 col-md-6 col-sm-12 d-flex">
                                                <div className='d-flex align-items-center ml-1 status-wrapper'>
                                                    <div className='d-flex align-items-center cursor-pointer justify-content-center' onClick={() => this.setStatus("TIMER")}>
                                                        {
                                                            this.state.showTimer ? <div className="active-check-box">
                                                                <img className="green-tick-icon" src={getImageSource(ImageConstants.GREEN_CHECK_BOX)} />
                                                            </div>
                                                                :
                                                                <div className="">
                                                                    <img className="gray-tick-icon" src={getImageSource(ImageConstants.GRAY_CHECK_BOX)} />
                                                                </div>
                                                        }
                                                    </div>
                                                    <div className="timer-wrapper-for-timer d-flex align-items-center">
                                                        <img className='timer-image pl-2' src={getImageSource(ImageConstants.BLOCK_TIMER)} />
                                                        <span className='timer-text pl-2'>Show Timer</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> */}
                                        <div className='row'>
                                            <div className="col-lg-3 col-md-6 col-sm-12 d-flex">
                                                <div className='d-flex align-items-center ml-1 status-wrapper'>
                                                    <div className='d-flex align-items-center cursor-pointer justify-content-center' onClick={() => this.setStatus("LEADERBOARD")}>
                                                        {
                                                            this.state.showLeaderboard ? <div className="active-check-box">
                                                                <img className="green-tick-icon" src={getImageSource(ImageConstants.GREEN_CHECK_BOX)} />
                                                            </div>
                                                                :
                                                                <div className="">
                                                                    <img className="gray-tick-icon" src={getImageSource(ImageConstants.GRAY_CHECK_BOX)} />
                                                                </div>
                                                        }
                                                    </div>
                                                    <div className="timer-wrapper-for-timer d-flex align-items-center">
                                                        <img className='timer-image pl-2' src={getImageSource(ImageConstants.LEADER_BOARD_ICON)} />
                                                        <span className='timer-text pl-2'>Show Leaderboard</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="ml-1 pt-3">
                                                {
                                                    this.state.showLeaderboard ?
                                                        <div className=''>
                                                            <div className='d-flex align-items-center cursor-pointer' onClick={() => this.setLeaderboardLimit('5')} >
                                                                <div className={`radio-circle d-flex align-items-center justify-content-center ${this.state.leaderboardLimit === '5' ? 'radio-circle-active' : ''}`}>
                                                                    {
                                                                        this.state.leaderboardLimit === '5' ? <div className='radio-inner-circle'></div> : <></>
                                                                    }
                                                                </div>
                                                                <div className='pl-2 timer-text'>Show Top 5 Students in Leaderboard</div>
                                                            </div>
                                                            <div className='d-flex align-items-center mt-1 cursor-pointer' onClick={() => this.setLeaderboardLimit('10')} >
                                                                <div className={`radio-circle d-flex align-items-center justify-content-center ${this.state.leaderboardLimit === '10' ? 'radio-circle-active' : ''}`}>
                                                                    {
                                                                        this.state.leaderboardLimit === '10' ? <div className='radio-inner-circle'></div> : <></>
                                                                    }
                                                                </div>
                                                                <div className='pl-2 timer-text'>Show Top 10 Students in Leaderboard</div>
                                                            </div>
                                                            {/* <div className='d-flex align-items-center mt-1 cursor-pointer' onClick={() => this.setLeaderboardLimit('ALL')}>
                                                                <div className={`radio-circle d-flex align-items-center justify-content-center ${this.state.leaderboardLimit === 'ALL' ? 'radio-circle-active' : ''}`}>
                                                                    {
                                                                        this.state.leaderboardLimit === "ALL" ? <div className='radio-inner-circle'></div> : <></>
                                                                    }
                                                                </div>
                                                                <div className='pl-2 timer-text'>Show All Students in Leaderboard</div>
                                                            </div> */}
                                                        </div>
                                                        :
                                                        <></>
                                                }
                                            </div>
                                        </div>
                                    </>
                                    :
                                    <></>
                            }


                        </div> : ""

                }
                {
                    this.state.showHomeworkAlreadyCreatedForSetPopup ?
                        <CwConfirmationModal
                            onOk={() => this.onOk()}
                            close={() => this.cancelPopup()}
                            message={'Selected Set School Assignment already done. Are want to create the Same Set School Assignment Again ?'}
                        />
                        : <></>
                }
            </div>

        );
    }
}

export default FilterComponent;